export const commonColumns = [
  {Header: '', accessor: 'checked'},
  {Header: 'תאריך העסקה', accessor: 'officialDate'},
  {Header: 'גוש', accessor: 'gush'},
  {Header: 'חלקה', accessor: 'helka'},
  {Header: 'ישוב', accessor: 'cityName'},
  {Header: 'רחוב', accessor: 'streetName'},
  {Header: 'בית', accessor: 'houseNum'},
  {Header: 'שטח רשום', accessor: 'houseRegisteredArea'},
  {Header: 'מס\' חדרים', accessor: 'houseRoomCount'},
  {Header: 'קומה', accessor: 'floor'},
  {Header: 'מס\' קומות', accessor: 'buildingFloorsCount'},
  {Header: 'גיל בניין', accessor: 'buildingAge'},
  {Header: 'חניה צמודה', accessor: 'houseParking'},
  {Header: 'מעלית', accessor: 'buildingElevator'},
  {Header: 'חצר', accessor: 'houseYard'},
  {Header: 'מחסן', accessor: 'houseStorage'},
  {Header: 'גג', accessor: 'houseRoof'},
  {Header: 'שטח מגרש', accessor: 'registeredArea'},
  {Header: 'שווי', accessor: 'price'},
  {Header: '', accessor: 'edit'}
];

export const surveyAssetsColumns = [
  {Header: '', accessor: 'checked'},
  {Header: 'ישוב', accessor: 'cityName'},
  {Header: 'רחוב', accessor: 'streetName'},
  {Header: 'בית', accessor: 'houseNum'},
  {Header: 'שטח במ"ר', accessor: 'houseRegisteredArea'},
  {Header: 'מס\' חדרים', accessor: 'houseRoomCount'},
  {Header: 'קומה', accessor: 'floor'},
  {Header: ' מס\' קומות', accessor: 'buildingFloorsCount'},
  {Header: 'שנת בניה', accessor: 'buildYear'},
  {Header: 'חניה צמודה', accessor: 'houseParking'},
  {Header: 'מעלית', accessor: 'buildingElevator'},
  {Header: 'חצר', accessor: 'houseYard'},
  {Header: 'מחסן', accessor: 'houseStorage'},
  {Header: 'גג', accessor: 'houseRoof'},
  {Header: 'מרפסת', accessor: 'houseBalconyCount'},
  {Header: 'מחיר מבוקש', accessor: 'askingPrice'},
  {Header: 'הגורם המשווק', accessor: 'marketingFactor'},
  {Header: '', accessor: 'edit'}
];

export const crawlerTab5Columns = [
  {Header: '', accessor: 'checked'},
  {Header: 'תאריך העסקה', accessor: 'purchaseDate'},
  {Header: 'גוש', accessor: 'gush'},
  {Header: 'חלקה', accessor: 'helka'},
  {Header: 'תת חלקה', accessor: 'ttHelka'},
  {Header: 'ישוב', accessor: 'cityName'},
  {Header: 'רחוב', accessor: 'streetName'},
  {Header: 'בית', accessor: 'houseNum'},
  {Header: 'תמורה מוצהרת', accessor: 'publicPrice'},
  {Header: 'שווי מכירה', accessor: 'salePrice'},
  {Header: 'חלק נמכר', accessor: 'soldPart'},
  {Header: 'שטח רשום', accessor: 'registeredArea'},
  {Header: 'שטח ארנונה', accessor: 'municipalArea'},
  {Header: 'מס\' חדרים', accessor: 'roomCount'},
  {Header: 'קומה', accessor: 'floor'},
  {Header: 'דירות בבנין', accessor: 'apartmentCount'},
  {Header: 'שנת בניה', accessor: 'buildYear'},
  {Header: 'כניסה', accessor: 'entrence'},
  {Header: 'דירה', accessor: 'apartmentNumber'},
  {Header: 'חניה', accessor: 'parking'},
  {Header: 'מעלית', accessor: 'elevator'},
  {Header: 'גלריה', accessor: 'gallery'},
  {Header: 'חצר', accessor: 'yard'},
  {Header: 'מחסן', accessor: 'storage'},
  {Header: 'גג', accessor: 'roof'},
  {Header: 'מגרש', accessor: 'lot'},
  {Header: 'סוג עסקה', accessor: 'dealType'},
  {Header: 'תפקוד הבנין והיחידה', accessor: 'unitPurpase'}
];

export const taxAuthorityColumns = [
  {Header: '', accessor: 'checked'},
  {Header: 'גוש וחלקה', accessor: 'gushHelkaTtHelka'},
  {Header: 'תאריך עסקה', accessor: 'saleDate'},
  {Header: 'יישוב', accessor: 'city'},
  {Header: 'רחוב', accessor: 'street'},
  {Header: 'בית', accessor: 'houseNumber'},
  {Header: 'כניסה', accessor: 'entranceNumber'},
  {Header: 'דירה', accessor: 'apartmentNumber'},
  {Header: 'מחיר מוצהר', accessor: 'salePrice'},
  {Header: 'מחיר מוערך', accessor: 'estimatePrice'},
  {Header: 'סוג שטח ברוטו', accessor: 'brutoAreaType'},
  {Header: 'שטח ברוטו', accessor: 'brutoAreaInSquareMeters'},
  {Header: 'סוג שטח נטו', accessor: 'netAreaType'},
  {Header: 'שטח נטו', accessor: 'netAreaInSquareMeters'},
  {Header: 'שנת בנייה', accessor: 'buildYear'},
  {Header: 'מחיר לחדר', accessor: 'pricePerRoom'},
  {Header: 'מחיר למטר', accessor: 'pricePerSquareMeter'},
  {Header: 'מספר חדרים', accessor: 'roomCount'},
  {Header: 'קומה', accessor: 'floor'},
  {Header: 'מספר קומות', accessor: 'floorsCount'},
  {Header: 'מספר דירות בבניין', accessor: 'roomsCount'},
  {Header: 'חניה', accessor: 'parking'},
  {Header: 'מעלית', accessor: 'elevator'},
  {Header: 'גג', accessor: 'roof'},
  {Header: 'מחסן', accessor: 'storage'},
  {Header: 'חצר', accessor: 'yard'},
  {Header: 'מגרש', accessor: 'lot'},
  {Header: 'גלריה', accessor: 'gallery'},
  {Header: 'סוג עסקה', accessor: 'sellType'},
  {Header: 'תפקוד יחידה', accessor: 'propertyType'},
  {Header: 'חלקים', accessor: 'soldShare'},
  {Header: 'מהות זכות', accessor: 'essenseOfRight'},
  {Header: 'תפקוד בניין', accessor: 'buildingUnitFunction'},
  {Header: 'שטח לחדר', accessor: 'areaRooms'},
  {Header: 'התאמת מחיר לפי חלק נמכר', accessor: 'salePriceSoldShare'},
  {Header: '', accessor: 'edit'},
];